import ProfileDesktop from './Desktop/Profile';
import ProfileMobile from './Mobile/ProfileMobile';

const Profile = () => {
    return (
        <>
            <ProfileDesktop />
            <ProfileMobile />
        </>
    );
};

export default Profile;
